import { AutoMap } from '@automapper/classes';

export class ZoneSamplingConditionEntity {
    Id?: number;
    @AutoMap()
    VitesseVent?: number;
    @AutoMap()
    Meteo?: number;
    @AutoMap()
    Hygrometrie?: number;
    @AutoMap()
    ExpositionClimatique!: number;
}
